import $ from 'jquery';

const attrIsBusy = 'data-tn-is-busy';

class FormButtonHandler {
  listen() {
    $(document).on('submit', 'form', (event) => {
      const $btn = $(event.currentTarget).find("button[type='submit']");
      // this.applyBusyStyling($btn);
    });
  }

  applyBusyStyling(element, { disableElement = true } = {}) {
    const $el = $(element);

    if ($el.length === 0) {
      return;
    }

    if (this.getIsButtonBusy($el)) {
      return;
    }

    $el.attr(attrIsBusy, true);

    const $waitingIcon = $('<span class="tn-waiting" aria-hidden="true"></span>');

    $el.append($waitingIcon);

    if (disableElement) {
      $el.prop('disabled', true);
    } else {
      $el.attr('aria-disabled', true);
      $el.addClass('disabled');
    }
  }

  resetButtonStyling() {
    const $btn = $("button[type='submit']");

    $btn.prop('disabled', false);
    $btn.removeAttr('aria-disabled');
    $btn.removeClass('disabled');

    const $icon = $($btn).find('span.tn-waiting');
    $icon.remove();

    $btn.removeAttr(attrIsBusy);
  }

  resetStyling(element) {
    const $el = $(element);
    const $icon = $el.find('span.tn-waiting');

    $icon.remove();

    $el.prop('disabled', false);
  }

  getIsButtonBusy = (el) => !!$(el).attr(attrIsBusy);
}

export default FormButtonHandler;
